import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import leftarrow from '../../../safreeimg/left-arrow.png';

const OrgUserMap = () => {
    const [location, setLocation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const navigate = useNavigate();

    const fetchLocation = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) {
                setError('No token found');
                setLoading(false);
                return;
            }

            const hashId = window.location.hash.replace('#', '');
            if (!hashId) {
                setError('No ID found in URL');
                setLoading(false);
                return;
            }

            const response = await axios.get(`https://api.safree.org/api-v2022/organization/auth/v1/user-last-checkin/${hashId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data?.data?.location) {
                setLocation(response.data.data.location);
            } else {
                setError('Location data not found');
            }
        } catch (err) {
            setError('Error fetching data: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLocation();
    }, []);

    const handleBackClick = () => {
        navigate(-1);
    };

    if (loading) return <div className='loading'><img src={Loader} alt='Loading...' /></div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className='container user-management'>
            <div className='row header'>
                <div className='col-md-6'>
                    <p className='sub-heading'><img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" />User Location</p>
                </div>
                <div className="col-md-6 altitude">
                        <p><strong>Latitude:</strong> {location.latitude }</p>
                        <p><strong>Longitude:</strong> {location.longitude }</p>
                </div>
            </div>             

            {location && (
                <MapContainer
                    center={[parseFloat(location.latitude), parseFloat(location.longitude)]}
                    zoom={13}
                    style={{ height: '423px', width: '100%' , borderRadius: '11px' }}
                >
                    <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
                    <Marker
                        position={[parseFloat(location.latitude), parseFloat(location.longitude)]}
                        icon={new L.Icon({
                            iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
                            iconSize: [25, 41],
                            iconAnchor: [12, 41]
                        })}
                    >
                        <Popup>
                            <strong>Location:</strong> {location.raw}
                        </Popup>
                    </Marker>
                </MapContainer>
            )}
           
        </div>
    );
};

export default OrgUserMap;
